class propertyCity {
    constructor(inputElement, searchResultElement) {
        this.searchInput = inputElement;
        this.searchResult = searchResultElement;
        this.inputElementId = $(inputElement).attr("id");
        this.addEvents();
    }

    addEvents() {
        this.searchInput.addEventListener(
            "input",
            this.displayResults.bind(this, this.searchInput)
        );
        this.searchResult.querySelectorAll("li").forEach((item) => {
            item.addEventListener(
                "click",
                this.updateSearchBox.bind(this, item)
            );
        });
    }

    displayResults(inputElement) {
        if (inputElement.value) {
            this.showAddressSearchResults();
        } else {
            this.hideAddressSearchResults();
        }
    }

    showAddressSearchResults() {
        this.searchResult.classList.remove("d-none");
        document.addEventListener(
            "click",
            this.onOutsideClickAddress.bind(this)
        );
    }

    hideAddressSearchResults() {
        this.searchResult.classList.add("d-none");
        document.removeEventListener(
            "click",
            this.onOutsideClickAddress.bind(this)
        );
    }

    onOutsideClickAddress(event) {
        if (event.target === this.searchInput) return;
        if (this.searchResult) this.hideAddressSearchResults();
    }

    updateSearchBox(item) {
        const text = $(item)
            .find(".air-city")
            .clone() //clone the element
            .children() //select all the children
            .remove() //remove all the children
            .end() //again go back to selected element
            .text()
            .trim();
        this.searchInput.value = text;
        this.hideAddressSearchResults();
    }
}

const staysInputs = document.querySelectorAll(".searchProperty");
staysInputs.forEach((staysInput) => {
    const nearestLocationHead = staysInput.closest(".advance-content");
    if (nearestLocationHead) {
        const nearestStaysList =
            nearestLocationHead.querySelector(".search-result");
        if (nearestStaysList) {
            new propertyCity(staysInput, nearestStaysList);
        }
    }
});

// JavaScript to handle the image and data-lang replacement
const languageDropdown = document.getElementById("languageDropdown");
const dropdownItems = document.querySelectorAll(".lang-drop");

dropdownItems.forEach((item) => {
    item.addEventListener("click", function () {
        const newImageSrc = item.querySelector("img").getAttribute("src");
        const newDataLang = item.getAttribute("data-lang");
        const newLanguageText = item.querySelector("p").textContent;

        // Update the button's image and data-lang attribute
        languageDropdown.querySelector("img").setAttribute("src", newImageSrc);
        languageDropdown.querySelector("span").textContent = newDataLang;

        // Update the dropdown item to show as active
        dropdownItems.forEach((item) => {
            item.classList.remove("active");
        });
        item.classList.add("active");
    });
});

var loginButton = document.querySelector(".login-link");
var passwordButton = document.querySelector(".login-password");
var signUpButton = document.querySelector(".signup-link");
var resetButton = document.querySelector(".otpRequest");
var loginTab = document.querySelector(".loginTab");
var signupTab = document.querySelector(".signupTab");
var conformationTab = document.querySelector(".conformationTab");
var otpTab = document.querySelector(".otpTab");

// Create a function to toggle the visibility of elements
function toggleTabVisibility(showTab, hideTabs) {
    showTab.classList.remove("d-none");
    for (var i = 0; i < hideTabs.length; i++) {
        hideTabs[i].classList.add("d-none");
    }
}

// Add event listeners for each button
loginButton.addEventListener("click", function () {
    toggleTabVisibility(loginTab, [signupTab, conformationTab, otpTab]);
});

passwordButton.addEventListener("click", function () {
    toggleTabVisibility(conformationTab, [loginTab, signupTab, otpTab]);
});

signUpButton.addEventListener("click", function () {
    toggleTabVisibility(signupTab, [loginTab, conformationTab, otpTab]);
});

resetButton.addEventListener("click", function () {
    toggleTabVisibility(otpTab, [conformationTab, loginTab, signupTab]);
});

var singleLink = document.querySelectorAll(".listing-card");
singleLink.forEach((element) => {
    element.addEventListener(
        "click",
        function () {
            window.location.href = "/real-estate/property-view";
        },
        false
    );
});

var singleLinkPlaceholder = document.querySelectorAll(".placeholder-card");
singleLinkPlaceholder.forEach((element) => {
    element.addEventListener(
        "click",
        function () {
            window.location.href = "/template/real-estate/property-view";
        },
        false
    );
});

function initializeRatingStars(selector) {
    const stars = document.querySelectorAll(selector);
    let selectedRating = 0;

    function highlightStars(index) {
        stars.forEach((star, i) => {
            star.classList.toggle("hovered", i <= index);
        });
    }

    function resetStars() {
        stars.forEach((star) => star.classList.remove("hovered"));
    }

    function setRating(selectedRating) {
        stars.forEach((star, i) => {
            star.classList.toggle("clicked", i < selectedRating);
        });
    }

    stars.forEach((star, index) => {
        star.addEventListener("mouseover", () => highlightStars(index));
        star.addEventListener("mouseout", () => {
            if (selectedRating === 0) {
                resetStars();
            }
        });
        star.addEventListener("click", () => {
            selectedRating = selectedRating === index + 1 ? index : index + 1;
            setRating(selectedRating);
        });
    });
}

initializeRatingStars(".property-rating .fa-star");

// const element = document.getElementById("faqReal");
// const navLink = document.getElementById("faqLink");
// navLink.addEventListener('click', ()=> {
//     element.scrollIntoView();
// });
